export default __webpack_public_path__ + "static/media/ApprovalRoundIcon.bc78c0ba.svg";